import styled, { css } from 'styled-components';

import type { Padding } from './OverlayImage';
import Link from 'Elements/Link';
import BaseIcon from 'Elements/Icon/Border';

export const Wrapper = styled(Link)<{ $padding: Padding }>`
    ${({ theme, $padding }) => css`
        ${getPadding($padding)}
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${theme.colors.primaryContrast.hex};
        height: 100%;
        text-decoration: none;
    `}
`;

export const ImageContainer = styled.figure<{ $backgroundColour?: string }>`
    ${({ theme, $backgroundColour }) => css`
        position: absolute;
        border-radius: 0.5rem;
        overflow: hidden;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 0;
        margin: 0;

        &:after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: rgba(${theme.colors.tertiary.rgb}, 0.7);

            ${$backgroundColour &&
            css`
                background: rgba(${$backgroundColour}, 0.9);
                filter: brightness(0.8);
            `}

            ${Wrapper}:hover & {
                filter: brightness(0.65);
            }
        }
    `}
`;

export const Label = styled.span`
    display: block;
    position: relative;
    margin: 0 2.2rem 0 0;
    font-size: 1.5rem;
    line-height: 1.2;
    font-weight: 700;
`;

export const IconStyled = styled(BaseIcon)`
    width: 3rem;
    min-width: 3rem;
    height: 3rem;
    font-size: 2rem;
    transition: transform 200ms ease;

    ${Wrapper}:hover & {
        transform: translateX(0.5rem);
    }
`;

const getPadding = (padding: Padding) => {
    switch (padding) {
        case 'thin':
            return css`
                padding: 1.5rem;
            `;
        case 'tall':
            return css`
                padding: 5rem 1.5rem;
            `;
        default:
            return css`
                padding: 3.5rem 1.5rem;
            `;
    }
};
